/**
 * Maps Voice Platform payloads to the callInfoData shape expected by Fonema UI components.
 *
 * @param {import('../voice/domain/voiceTypes').IncomingCallPayload} payload
 * @param {string} [registerNumber]
 * @returns {Object}
 */
// eslint-disable-next-line import/prefer-default-export
export function mapVoiceIncomingToCallInfoData(payload, registerNumber = '') {
  const isOutgoingCall = payload.direction === 'outgoing' || payload.direction === 'outbound';
  const callerNumber = isOutgoingCall ? payload.to : payload.from;
  const lineNumber = isOutgoingCall
    ? (payload.from || registerNumber)
    : (payload.to || registerNumber);

  return {
    callId: payload.callControlId,
    callerNumber,
    callDirection: isOutgoingCall ? 'outgoing' : 'incoming',
    registerNumber: lineNumber,
    callChannel: payload.channel ?? 'unknown',
    voice: {
      callControlId: payload.callControlId,
      callSessionId: payload.callSessionId,
      callLegId: payload.callLegId,
      from: payload.from,
      to: payload.to,
      timestamp: payload.timestamp,
      channel: payload.channel ?? 'unknown'
    }
  };
}
